import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { SEO } from '../utils';
import { connect } from 'react-redux';
import { userActions } from '../redux/actions';

import { startLoader } from '../components/common/Loader';
import { HeroBannerBlock, SponsorsBlock } from '../components';

import '../assets/styles/pages/_sponsors.scss';

const Sponsors = ({ match, sponsors: sponsorsData, getSponsors, ...props }) => {
  const [sponsors, setSponsors] = useState('');
  useEffect(() => {
    props.getMeta('Sponsors');
    startLoader();
  }, [match, match.params]);

  useEffect(() => {
    getSponsors().then((response) => {
      setSponsors(response.res);
    });
  }, [getSponsors]);
  const metaData = props.metaData?.res;
  return (
    <div className='sponsors'>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />
      <HeroBannerBlock
        bannerData={sponsors && sponsors.banner}
        downloadBtn
        downloadBtnWhite
        downloadUrl={sponsors && sponsors?.document && sponsors?.document?.url}
        btnTitle={sponsors && sponsors?.document && sponsors?.document?.label}
      />
      <SponsorsBlock sponsors={sponsors && sponsors.data} />
    </div>
  );
};

Sponsors.propTypes = {
  sponsors: PropTypes.object,
  getSponsors: PropTypes.func,
  match: PropTypes.object,
};

function mapState (state) {
  return {
    sponsors: state.getSponsors, metaData: state.getMeta,
  };
}
const actionCreators = {
  getSponsors: userActions.getSponsors, getMeta: userActions.getMetaData,
};
Sponsors.fetchMeta = () => actionCreators.getMeta('Sponsors');
Sponsors.serverFetch = actionCreators.getSponsors;

export default connect(mapState, actionCreators)(Sponsors);
